import { useState, useCallback, useEffect } from 'react'

const SCROLL_LOCK_CLASS = 'disable-page-scroll'

// Shared open/close state for the redesigned mobile navigation. State is lifted
// here so the future slimmed mobile menu can read `isActive` from Navigation and
// render in place, without the Hamburger owning it. Mirrors LegacyNavigation.
function useHamburgerStatus() {
  const [isActive, setIsActive] = useState(false)

  const toggle = useCallback(() => {
    setIsActive(state => !state)
  }, [])

  // Lock body scroll while the menu is open. Driven off state so the class
  // stays in sync and is always cleared when the nav unmounts.
  useEffect(() => {
    document.body.classList.toggle(SCROLL_LOCK_CLASS, isActive)

    return () => {
      document.body.classList.remove(SCROLL_LOCK_CLASS)
    }
  }, [isActive])

  return { isActive, toggle }
}

export { useHamburgerStatus }
